import React from 'react';
import { useRouter } from 'next/router';

import { PageId } from 'utils/ubi/pageId';
import assemblePath from 'utils/assemblePath';

import InternalLink, { HrefFunction, LinkProps } from './InternalLink';

const articleLinkBuilderFactory =
  (slug: string, isPlain: boolean): HrefFunction =>
  (market, verticalParam) =>
    assemblePath(market, verticalParam, 'article', slug, isPlain ? 'plain' : '');

interface ArticleLinkProps extends LinkProps {
  slug: string;
}

const ArticleLink = ({ slug, ...props }: ArticleLinkProps) => {
  const isPlain = useRouter().asPath.includes('/plain/');
  return <InternalLink toPage={PageId.Article} hrefFun={articleLinkBuilderFactory(slug, isPlain)} {...props} />;
};

export default ArticleLink;
